<template>
	<view class="box">
		<!-- 查找/对比 -->
		<div class="report">
			<div class="report_sty">
				<div>
					<img class="report_img" src="../../static/chazhaobaogao.png" alt="">
				</div>
				<div class="report_sty1">
					<span class="report_txt1">查找报告</span>
					<span class="report_txt2">手机号/卡号等绑定报告</span>
				</div>
			</div>
			<div class="report_sty" @click="ComparisonReport">
				<div>
					<img class="report_img" src="../../static/duibibaogao.png" alt="">
				</div>
				<div class="report_sty1">
					<span class="report_txt1">对比报告</span>
					<span class="report_txt2">历年报告数据对比</span>
				</div>
			</div>
		</div>

		<!-- 卡片 -->
		<div class="card" @click="ReportDetails">
			<div class="card_sty">
				<div class="card_left">
					<span class="card_left_txt1">xxx</span>
					<span class="card_left_txt2">男</span>
				</div>
				<div class="card_right">
					<div class="card_right1">
						<span class="card_right_txt1">2022-04-08</span>
						<span class="card_right_txt2">爱康卓悦西安行政中心尚国</span>
						<span class="card_right_txt3">卡号：1234567891234567891</span>
					</div>
					<div class="card_right2">
						<span class="card_right_txt4">体</span>
						<span class="card_right_txt4">检</span>
						<span class="card_right_txt4">报</span>
						<span class="card_right_txt4">告</span>
					</div>
				</div>
			</div>
			
		</div>

	</view>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		methods: {
		ComparisonReport() {
			uni.navigateTo({
				url: '/pages/ComparisonReport/ComparisonReport'
			})
		},
		ReportDetails() {
			uni.navigateTo({
				url: '/pages/ReportDetails/ReportDetails'
			})
		}
		}
	}
</script>

<style lang="scss">
	.box {
		width: 100%;
		min-height: 1240rpx;
		background: linear-gradient(180deg, #fd8b4d, #f4f8f7, #f7f7f7 40%, );
	}

	.report {
		padding-top: 60px;
		display: flex;
		justify-content: space-around;
	}

	.report_sty {
		background-color: #ffffff;
		width: 350rpx;
		height: 200rpx;
		border-radius: 10%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-around;
	}

	.report_img {
		width: 35px;
		height: 35px;
	}

	.report_sty1 {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}

	.report_txt1 {
		font-size: 20px;
		font-weight: 800;
	}

	.report_txt2 {
		font-size: 12px;
		color: #838383;

	}

	.card {
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.card_sty{
		width: 670rpx;
		height: 150rpx;
		border-radius: 8px 8px 8px 8px;
		background-color: #fff;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.card_left{
		width: 120rpx;
		height: 103rpx;
		border-right: 1px solid #ccc;
		display: flex;
		align-items: center;
		flex-direction: column;
	}
	.card_left_txt{
		font-size: 16px;
	}
	.card_left_txt2{
		font-size: 14px;
		color: #838383;
	}
	.card_right{
		display: flex;
	}
	.card_right1{
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}
	.card_right_txt1{
		font-size: 14px;
	}
	.card_right_txt2{
		font-size: 14px;
	}
	.card_right_txt3{
		font-size: 14px;
	}
	.card_right2{
		margin-left: 10px;
		width: 50rpx;
		height: 150rpx;
		font-size: 14px;
		color: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		border-radius: 0px 8px 8px 0px;
		background-color: #fd8b4d;
	}
	.card_right_txt4{
		font-size: 14px;
		color: #fff;
	}
</style>
